<div class="main-container">
  <div class="input d-flex justify-content-between" [ngClass]="{'disabled-input': isDisabled}">
    <div class="dropdown-container">
      <select
        class="downdown-value align-middle"
        [disabled]="isDisabled"
        [(ngModel)]="value.salutation"
        (ngModelChange)="onValueChange()"
      >
        <option [value]="null" hidden>- Title -</option>
        <option *ngFor="let item of salutations" [value]="item.key">{{ item.name }}</option>
      </select>
    </div>
    <div style="flex: 1;">
      <input
        appRestrictSpecialChars appRestrictNumbers
        placeholder="Enter First Name"
        type="text"
        class="user-name"
        [disabled]="isDisabled"
        [(ngModel)]="value.firstName"
        (ngModelChange)="onValueChange()"
        [appMaxLength]="maxLength"
      />
    </div>
  </div>
</div>
